var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.isSubmittable ? 'form' : 'div',{tag:"div",staticClass:"form",attrs:{"novalidate":_vm.noValidate},on:{"submit":function($event){$event.preventDefault();return _vm.emitEvent({ name: 'submit', payload: $event })}}},[_vm._t("default"),(_vm.$slots.footer)?[_c('div',{staticClass:"form__footer"},[_vm._t("footer")],2)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }